import styled from "styled-components";

export const MarketingInlineLink = styled.a`
    text-decoration: none;
    color:  ${({ theme }) => theme ? theme.marketing.colors.dodgerBlue100 : null};
    word-break: break-all;
    
    &:hover {
        color:  ${({ theme }) => theme ? theme.marketing.colors.chathamsBlue : null};
    }
`;